import { render, staticRenderFns } from "./ELNotification.vue?vue&type=template&id=3dc3b88f&scoped=true"
import script from "./ELNotification.vue?vue&type=script&lang=js"
export * from "./ELNotification.vue?vue&type=script&lang=js"
import style0 from "./ELNotification.vue?vue&type=style&index=0&id=3dc3b88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3b88f",
  null
  
)

export default component.exports